module.exports = __webpack_public_path__ + "img/google_logo.d5ad2680.svg";